// KİMÖ-405 Kimya Dersi Öğretim Programları — TYMM Ortak Metin Ders Notları
export const BUTUNLESIK = [
  ["KB2.1", "Çelişki Giderme Becerisi", "İki ya da daha fazla durum arasındaki tutarsızlığı düzeltme çabasıdır."],
  ["KB2.2", "Gözlemleme Becerisi", "Doğal ortamdaki nesne ve olaylara ait özelliklerin duyular aracılığıyla belirlenmesidir."],
  ["KB2.3", "Özetleme Becerisi", "Bir metnin ya da konuşmanın özünü anlamayı, ana hatlarıyla kısaltarak kendi cümleleriyle aktarmayı ifade eder."],
  ["KB2.4", "Çözümleme Becerisi", "Bir bütünü parçalarına ayırarak parçalar arasındaki ilişkileri belirlemedir."],
  ["KB2.5", "Sınıflandırma Becerisi", "Nesne, olgu ya da olayları özelliklerine ve aralarındaki ilişkilere göre gruplara ayırmadır."],
  ["KB2.6", "Bilgi Toplama Becerisi", "İstenen bilgiyi çeşitli yöntemlerle elde etme, doğrulama ve kaydetmedir."],
  ["KB2.7", "Karşılaştırma Becerisi", "Birden fazla kavram ya da durum arasındaki benzerlik ve farklılıkları belirlemedir."],
  ["KB2.8", "Sorgulama Becerisi", "Farkında olma, anlamlı sorular sorma, bilgi edinme ve değerlendirme sürecidir."],
  ["KB2.9", "Genelleme Becerisi", "Olayları araştırma ve aralarındaki özellikleri ilişkilendirip genişleterek bir yargıya varmadır."],
  ["KB2.10", "Çıkarım Yapma Becerisi", "Önerme ve varsayımlara dayalı olarak sonuca ulaşmadır."],
  ["KB2.11", "Gözleme Dayalı Tahmin Etme Becerisi", "Ön gözlem veya deneyimlerden yola çıkarak çıkarım yapma ve yargıda bulunmadır."],
  ["KB2.12", "Mevcut Bilgiye/Veriye Dayalı Tahmin Etme Becerisi", "Eldeki veriler üzerinden hesaplamalar yaparak yargıda bulunmadır."],
  ["KB2.13", "Yapılandırma Becerisi", "Mevcut durumdan hareketle ilişkileri görme ve bunlardan uyumlu bir bütün oluşturmadır."],
  ["KB2.14", "Yorumlama Becerisi", "Mevcut durumu bağlamından koparmadan kendi ifadeleriyle yeniden açıklamadır."],
  ["KB2.15", "Yansıtma Becerisi", "Bir durumu gelecekteki durumlara uygulamak için deneyimlerden yola çıkarak gözden geçirme, çıkarımda bulunma ve değerlendirmedir."],
  ["KB2.16", "Muhakeme (Akıl Yürütme) Becerisi", "Tümevarım, tümdengelim ve analoji yaklaşımlarını kullanarak çıkarımlara ulaşmadır. Alt türleri: KB2.16.1 Tümevarımsal, KB2.16.2 Tümdengelimsel, KB2.16.3 Analojik Akıl Yürütme."],
  ["KB2.17", "Değerlendirme Becerisi", "Ölçüt belirleyerek ölçme yapma ve sonuçları ölçütlerle karşılaştırarak yargıda bulunmadır."],
  ["KB2.18", "Tartışma Becerisi", "Görüşlerini mantıksal çerçevede sunma, başka görüşleri dinleme ve mantıksal açıdan kıyaslamadır."],
  ["KB2.19", "Mantıksal Denetleme Becerisi", "Bir önerme ya da çıkarımı formel olarak akıl ilkeleri ve akıl yürütme biçimlerine uygun işe koşmadır."],
  ["KB2.20", "Sentezleme Becerisi", "Parçalar arasında ilişki kurarak parçaları ÖZGÜN bir bütün oluşturmak yoluyla bir araya getirmedir."],
];

export const k405Notes = [
  {
    id: "t1",
    no: "Bölüm 1",
    title: "Temel Yaklaşım ve Öğrenci Profili",
    sections: [
      {
        h: "1.1 Türkiye Yüzyılı Maarif Modeli (TYMM) Vizyonu",
        blocks: [
          { p: "Modelin vizyonu ==**\"Köklerden Geleceğe\"**==dir. Amaç; ==**aklıselim, kalbiselim ve zevkiselim**== sahibi, yetkin ve erdemli nesiller yetiştirmektir." },
          { p: "Model şu **denge** alanlarını gözetir: ==**madde – mana**==, ==**akıl – duygu**==, ==**nefis – vicdan**==, ==**insan – toplum**==, ==**zaman – mekân**==." },
          { ul: [
            "__**Bilme ve sorumluluk bütünlüğü:**__ Bilgi, ahlaki sorumlulukla birlikte ele alınır; ==bilen insan bildiğinin sorumluluğunu da taşır==.",
            "__**Temel politika:**__ Türkçenin korunması, geliştirilmesi ve doğru kullanımı tüm programlarda ortak hedeftir.",
            "Öğrenci profili: ==**Yetkin ve Erdemli İnsan**==.",
          ] },
        ],
      },
      {
        h: "1.2 Öğrenci Profilinin 4 Felsefi Temeli",
        blocks: [
          { table: { head: ["Bütünlük Alanı", "Odak", "Açıklama"], rows: [
            ["__**Ontolojik Bütünlük**__", "==Ruh ve Beden Bütünlüğü==", "İnsanın ruh ve beden, akıl ve vicdan uyumu içinde bir bütün olarak ele alınması."],
            ["__**Epistemolojik Bütünlük**__", "==Bilgi ve Bilgelik==", "Bilginin sorun çözmede ve ahlaki kararlarda kullanılarak bilgeliğe dönüştürülmesi."],
            ["__**Zamansal Bütünlük**__", "==Geçmişten Geleceğe Eğitim==", "Tarihsel tecrübe ve ortak bilincin geleceğe taşınması."],
            ["__**Aksiyolojik Olgunluk**__", "==Ahlaki Bilinç ve Estetik Bakış Açısı==", "Değer temelli yaşam; ==**Erdem-Değer-Eylem Çerçevesi'nin temelini**== oluşturur."],
          ] } },
          { box: "Dikkat: Dördüncü alan \"bütünlük\" değil ==**\"Aksiyolojik Olgunluk\"**== olarak adlandırılır ve Erdem-Değer-Eylem Çerçevesi'ne temel oluşturur.", tone: "exam" },
        ],
      },
      {
        h: "1.3 10 Öğrenci Profil Özelliği",
        blocks: [
          { table: { head: ["Özellik", "Öne çıkan nitelikler"], rows: [
            ["Ahlaklı", "Doğru, dürüst, adil, sorumluluk sahibi"],
            ["Bilge", "Bilgiyi hikmetle kullanan, derin düşünen"],
            ["Cesaretli", "Doğruyu savunan, risk alabilen, girişken"],
            ["Estetik", "Güzeli fark eden, zarafet ve sanat duyarlılığı"],
            ["İradeli", "Öz denetimli, kararlı, sabırlı"],
            ["Merhametli", "Şefkatli, empati kuran, yardımsever"],
            ["Sağlıklı", "Beden, zihin ve ruh sağlığına önem veren"],
            ["Sorgulayıcı", "Merak eden, eleştirel bakan, araştıran"],
            ["Üretken", "Yaratıcı, girişimci, katkı sağlayan"],
            ["Vatansever", "Vatanına, milletine, kültürüne bağlı; sorumlu vatandaş"],
          ] } },
        ],
      },
    ],
  },
  {
    id: "t2",
    no: "Bölüm 2",
    title: "Erdem-Değer-Eylem Çerçevesi ve Program Tasarımı",
    sections: [
      {
        h: "2.1 Çatı Değerler ve Değer Eksenleri",
        blocks: [
          { p: "__**Çatı değerler:**__ ==**Saygı – Sorumluluk – Adalet.**==" },
          { table: { head: ["Değer Ekseni", "Değerler"], rows: [
            ["**Huzurlu İnsan**", "==Çalışkanlık, Mahremiyet, Mütevazılık, Sabır, Sağlıklı Yaşam, Tasarruf=="],
            ["**Huzurlu Aile ve Toplum**", "==Aile Bütünlüğü, Dostluk, Dürüstlük, Özgürlük, Sevgi, Vatanseverlik, Yardımseverlik=="],
            ["**Yaşanabilir Çevre**", "==Duyarlılık, Estetik, Merhamet, Temizlik=="],
          ] } },
        ],
      },
      {
        h: "2.2 Bütüncül Eğitim Modeli Bileşenleri",
        blocks: [
          { ol: [
            "__**Öğrenme Çıktıları Çerçevesi:**__ Alana ait bilgi kümeleri + Kavramsal beceriler + Alan becerileri.",
            "__**Öğrenme Kanıtları:**__ ==Ölçme ve değerlendirme==.",
            "**Öğrenme-Öğretme Yaşantıları.**",
            "__**Farklılaştırılmış Öğretim:**__ ==Zenginleştirme ve Destekleme==.",
            "__**Programlar Arası Bileşenler:**__ ==Sosyal-Duygusal Öğrenme Becerileri [Benlik, Sosyal Yaşam, Ortak/Birleşik], Erdem-Değer-Eylem, Sistem Düşüncesi ve Okuryazarlık Becerileri==.",
            "**Okul Temelli Planlama.**",
            "**Program Dışı Etkinlikler.**",
            "**Öğretmen Yansıtmaları.**",
          ] },
          { p: "__**9 Okuryazarlık Becerisi:**__ ==Bilgi, Dijital, Finansal, Görsel, Kültür, Vatandaşlık, Veri, Sürdürülebilirlik, Sanat okuryazarlığı==." },
          { p: "__**Sosyal-Duygusal Öğrenme Becerileri**__ 3 boyutludur: ==**Benlik**, **Sosyal Yaşam**, **Ortak/Birleşik**== beceriler." },
        ],
      },
      {
        h: "2.3 Öğrenme-Öğretme Yaşantılarının 5 Bileşeni",
        blocks: [
          { flow: ["1. Temel Kabuller", "2. Ön Değerlendirme Süreci", "3. Köprü Kurma", "4. Öğrenme-Öğretme Uygulamaları", "5. Farklılaştırma Uygulamaları"] },
          { ul: [
            "__**Temel kabuller:**__ Öğrencinin sahip olduğu varsayılan ön bilgi ve beceriler.",
            "__**Ön değerlendirme:**__ Öğrencinin ==hazır bulunuşluğunun belirlenmesi==.",
            "__**Köprü kurma:**__ Yeni öğrenmenin ==önceki öğrenmeler, günlük yaşam ve diğer disiplinlerle ilişkilendirilmesi==.",
            "__**Öğrenme-öğretme uygulamaları:**__ Öğrenme çıktılarına ulaştıran etkinlikler.",
            "__**Farklılaştırma:**__ Zenginleştirme (ileri düzey) ve destekleme (ek desteğe ihtiyaç duyan) uygulamaları.",
          ] },
        ],
      },
    ],
  },
  {
    id: "t3",
    no: "Bölüm 3",
    title: "Kavramsal Beceriler (KB) – Sınavın En Önemli Bölümü",
    sections: [
      {
        h: "3.1 Kavramsal Becerilerin 3 Boyutu",
        blocks: [
          { table: { head: ["Boyut", "Kod", "Sayı", "Tanım"], rows: [
            ["Temel Beceriler", "KB1", "—", "Karmaşık süreç gerektirmeden edinilen, ==**gözlenebilen**== eylemler."],
            ["Bütünleşik Beceriler", "KB2", "==**20**==", "Temel becerilerin birleşimiyle oluşan, süreç gerektiren beceriler."],
            ["Üst Düzey Düşünme Becerileri", "KB3", "==**3**==", "Bütünleşik becerilerden ==**en az ikisini**== içerir."],
          ] } },
          { box: "Temel ve bütünleşik beceriler arasında ==**aşamalılık ilişkisi yoktur**==; bu beceriler üst düzey düşünme becerilerinin ==**altyapısını**== oluşturur.", tone: "exam" },
          { p: "**Temel beceriler (KB1) örnekleri:** ==Saymak, okumak, yazmak, çizmek, bulmak, seçmek, belirlemek, işaret etmek, ölçmek, sunmak, çevirmek, kaydetmek==." },
        ],
      },
      {
        h: "3.2 Bütünleşik Beceriler (KB2) – Tam 20 Adet",
        blocks: [
          { skills: true },
          { box: "__**Yapılandırma (KB2.13) ≠ Sentezleme (KB2.20):**__ Yapılandırmada mevcut durumdaki ilişkiler görülerek ==**uyumlu**== bir bütün oluşturulur; sentezlemede parçalar ilişkilendirilerek ==**ÖZGÜN**== (yeni, daha önce olmayan) bir bütün ortaya konur. Anahtar kelime: *uyumlu* → yapılandırma, *özgün* → sentezleme.", tone: "exam" },
          { box: "__**Tahmin becerileri ayrımı:**__ KB2.11 ==**Gözleme**== dayalı (ön gözlem/deneyim), KB2.12 ==**Mevcut bilgiye/veriye**== dayalı (hesaplama yaparak).", tone: "info" },
          { box: "__**Muhakeme (KB2.16)**__ üç alt türe sahiptir: ==**Tümevarımsal**== (özelden genele), ==**Tümdengelimsel**== (genelden özele), ==**Analojik**== (benzetme yoluyla) akıl yürütme.", tone: "info" },
        ],
      },
      {
        h: "3.3 Üst Düzey Düşünme Becerileri (KB3) – 3 Adet",
        blocks: [
          { table: { head: ["Kod", "Beceri"], rows: [
            ["KB3.1", "Karar Verme Becerisi"],
            ["KB3.2", "Problem Çözme Becerisi"],
            ["KB3.3", "Eleştirel Düşünme Becerisi"],
          ] } },
          { box: "==\"Eleştirel **düşünme**\" bir **KB3** becerisidir==; ==\"Eleştirel **bakma**\" ise bir **entelektüel eğilimdir (E3)**==. ==\"Karar verme\" ve \"Problem çözme\" bütünleşik beceri **değildir**==.", tone: "exam" },
        ],
      },
    ],
  },
  {
    id: "t4",
    no: "Bölüm 4",
    title: "Fiziksel Beceriler, Eğilimler ve Fen Bilimleri Alan Becerileri",
    sections: [
      {
        h: "4.1 Fiziksel Beceriler",
        blocks: [
          { p: "Zihinsel, sosyal ve duygusal boyutlarla **bütüncül** çalışan; kol, bacak, gövde ve kas gruplarının ==**doğru ve tutarlı**== hareketleridir (ör. deney düzeneği kurma, pipet kullanma, deney yapma)." },
        ],
      },
      {
        h: "4.2 Eğilimler (21 Adet – 3 Kategori)",
        blocks: [
          { p: "Eğilimler, becerileri ==**tetikleyen zihinsel örüntülerdir**==." },
          { table: { head: ["Kategori", "Sayı", "Eğilimler"], rows: [
            ["__**Benlik Eğilimleri (E1)**__", "6", "Merak, Bağımsızlık, Azim ve Kararlılık, Kendine İnanma (Öz Yeterlilik), Kendine Güvenme (Öz Güven), Seçicilik"],
            ["__**Sosyal Eğilimler (E2)**__", "5", "Empati, Sorumluluk, Girişkenlik, Güven, Oyunseverlik"],
            ["__**Entelektüel Eğilimler (E3)**__", "10", "Muhakeme, Odaklanma, Yaratıcılık, Gerçeği Arama, Açık Fikirlilik, Analitiklik, Sistematiklik, Soru Sorma, Şüphe Duyma, Eleştirel Bakma"],
          ] } },
          { box: "Toplam: 6 + 5 + 10 = ==**21 eğilim**==. Tuzaklar: ==**Merak** ve **Seçicilik** benlik (E1)==; ==**Sorumluluk** ve **Güven** sosyal (E2)==; ==**Yaratıcılık**, **Soru Sorma**, **Şüphe Duyma** entelektüel (E3)==.", tone: "exam" },
        ],
      },
      {
        h: "4.3 Fen Bilimleri Alan Becerileri (FBAB – 13 Adet)",
        blocks: [
          { table: { head: ["Kod", "Alan Becerisi"], rows: [
            ["FBAB1", "Bilimsel Gözlem"], ["FBAB2", "Sınıflandırma"], ["FBAB3", "Bilimsel Gözleme Dayalı Tahmin"], ["FBAB4", "Bilimsel Veriye Dayalı Tahmin"],
            ["FBAB5", "Operasyonel Tanımlama"], ["FBAB6", "Hipotez Oluşturma"], ["FBAB7", "Deney Yapma"], ["FBAB8", "Bilimsel Çıkarım Yapma"],
            ["FBAB9", "Bilimsel Model Oluşturma"], ["FBAB10", "==Tümevarımsal Akıl Yürütme=="], ["FBAB11", "==Tümdengelimsel Akıl Yürütme=="], ["FBAB12", "Kanıt Kullanma"], ["FBAB13", "Bilimsel Sorgulama"],
          ] } },
          { box: "==**Hipotez oluşturma, deney yapma, operasyonel tanımlama, bilimsel model oluşturma ve kanıt kullanma**== kavramsal beceri listesinde (KB2) ==**yoktur**==; bunlar yalnızca ==**Fen Bilimleri alan becerileridir**==.", tone: "exam" },
        ],
      },
    ],
  },
];
